import { height, width, x, y } from './accessors.js';
import { getBarStyle } from './bar-style.js';
import { BarCanvas } from '../../../../core/components/canvas/components/BarCanvas.js';
import { useGridPlotSize } from '../../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useTimeseriesFilteredData } from '../../../hooks/useTimeseriesFilteredData.js';
import { useYScales } from '../../../hooks/useYScales.js';
import { useDisplayConfigContext } from '../DisplayConfigContext.js';
import { BaseDisplayProps } from '../shared/types.js';

/**
 * Displays the passed series as stacked bar chart.
 */
export const BarChartDisplay = ({ xScale }: BaseDisplayProps) => {
  const yScale = useYScales();
  const { highlightedSeriesIds } = useDisplayConfigContext();
  const { width: widthPlot, height: heightPlot } = useGridPlotSize();
  const {
    dataPerVariant: { bar: barSeries },
    seriesMap,
    datapointsMap,
  } = useTimeseriesFilteredData();

  return (
    <div data-testid="bar-chart-display">
      {barSeries.map((series) => {
        const seriesMetadata = safeGet(seriesMap, series);
        const { color, opacity } = getBarStyle(
          seriesMetadata,
          highlightedSeriesIds,
        );

        return (
          <BarCanvas
            key={seriesMetadata.id}
            data={series.datapoints}
            canvasWidth={widthPlot}
            canvasHeight={heightPlot}
            x={x(datapointsMap, xScale)}
            y={y(datapointsMap, yScale)}
            width={width(datapointsMap, xScale)}
            height={height(datapointsMap, yScale)}
            strokeWidth={1}
            color={() => color}
            opacity={() => opacity}
          />
        );
      })}
    </div>
  );
};

BarChartDisplay['displayName'] = 'BarChartDisplay';
